export const TRUSTPILOT_RATING = 4.7
